<template>
  <CardPrimary
    v-bind="$attrs"
    v-on="$listeners"
    :style="style.card"
  >
    <HeaderMediumPrimary>
      Co-edit requests
    </HeaderMediumPrimary>
    <TabPrimary
      v-model="tabIndex"
      :tabs="tabs"
      :style="style.tab"
    />
    <div :style="getCoeditedHistoryContainerStyle">
      <TextRegular v-if="coeditedTenantUserSkills.length === 0">
        You've received no co-edit request.
      </TextRegular>
      <template v-for="(tenantUserSkill, index) in coeditedTenantUserSkills">
        <div
          :key="`${index}_0`"
          :style="style.row"
        >
          <TagPrimary>
            {{ tenantUserSkill.skill.name }}
          </TagPrimary>
          <TextRegular :style="style.text">
            added by
          </TextRegular>
          <LinkNamePrimary
            v-if="tenantUserSkill.creater"
            :tenantUser="tenantUserSkill.creater"
            :truncate="true"
            :style="style.name"
          />
          <TextRegular
            v-else
            :truncate="true"
            :style="style.name"
          >
            deactivated user
          </TextRegular>
          <ButtonAction
            @click="$emit('edit-skill', tenantUserSkill)"
            :style="style.button"
          >
            Review
          </ButtonAction>
      </div>
      </template>
    </div>
    <div :style="getCoeditHistoryContainerStyle">
      <TextRegular v-if="tenantUserCoedits.length === 0">
        You've sent no co-edit request yet.
      </TextRegular>
      <template
        v-for="(tenantUserSkill, index) in tenantUserCoedits"
      >
      <div
        :key="`${index}_1`"
        :style="style.row"
      >
        <TagPrimary>
          {{ tenantUserSkill.skill.name }}
        </TagPrimary>
        <TextRegular :style="style.text">
          added to
        </TextRegular>
        <LinkNamePrimary
          v-if="tenantUserSkill.creater"
          :tenantUser="tenantUserSkill.tenantUser"
          :truncate="true"
          :style="style.name"
        />
        <TextRegular
          v-else
          :truncate="true"
          :style="style.name"
        >
          deactivated user
        </TextRegular>
        <ButtonSecondary @click="$emit('revoke-coedit', tenantUserSkill)">
          Revoke
        </ButtonSecondary>
      </div>
      </template>
    </div>
    <div
      v-if="tabIndex === 1 && moreTenantUserCoeditsExist"
      :style="style.bottomContainer"
    >
      <TextButtonMuted @click="$emit('see-more-coedits')">
        See more
      </TextButtonMuted>
    </div>
  </CardPrimary>
</template>

<script>
  import ButtonAction from '@modules/v2/button/button-action'
  import ButtonSecondary from '@modules/v2/button/button-secondary'
  import CardPrimary from '@modules/v2/card/card-primary'
  import HeaderMediumPrimary from '@modules/v2/header/header-medium-primary'
  import LinkNamePrimary from '@modules/v2/link/link-name-primary'
  import TabPrimary from '@modules/v2/tab/tab-primary'
  import TagPrimary from '@modules/v2/tag/tag-primary'
  import TextButtonMuted from '@modules/v2/button/text-button-muted'
  import TextRegular from '@modules/v2/text/text-regular'
  import { getCoeditedTenantUserSkills } from '@js/skill-utils'
  import { Layout } from '@js/styles'
  import { PAGE_SIZES } from '@js/constants'

  export default {
    name: 'CoeditHistory',
    inheritAttrs: false,
    components: {
      ButtonAction,
      ButtonSecondary,
      CardPrimary,
      HeaderMediumPrimary,
      LinkNamePrimary,
      TabPrimary,
      TagPrimary,
      TextButtonMuted,
      TextRegular,
    },
    props: {
      tenantUserCoeditCount: {
        type: [Object, Number],
        required: false,
        default: null,
      },
      tenantUserCoedits: {
        type: Array,
        required: false,
        default: () => [],
      },
      tenantUserSkills: {
        type: Array,
        required: false,
        default: () => [],
      },
      visitor: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    data: function () {
      return {
        tabIndex: 0,
        tabs: [
          {
            label: 'Received',
          },
          {
            label: 'Sent',
          },
        ],
        style: {
          bottomContainer: {
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
          },
          button: {
            margin: `0 0 0 ${Layout.space.sm}`,
          },
          card: {
            minHeight: '130px',
            padding: Layout.space.md,
            width: '100%',
          },
          name: {
            flex: 1,
            padding: `0 ${Layout.space.xs} 0 0`,
          },
          row: {
            alignItems: 'center',
            display: 'flex',
            height: '32px',
            margin: `${Layout.space.xs} 0`,
            width: '100%',
          },
          tab: {
            margin: `${Layout.space.md} 0 12px`,
          },
          text: {
            padding: `0 ${Layout.space.xs}`,
            whiteSpace: 'nowrap',
          },
        },
      };
    },
    computed: {
      coeditedTenantUserSkills: function () {
        return getCoeditedTenantUserSkills(this.visitor.id, this.tenantUserSkills);
      },
      getCoeditedHistoryContainerStyle: function () {
        return {
          display: this.tabIndex === 0 ? 'block' : 'none',
          maxHeight: '190px',
          minHeight: '48px',
          overflowX: 'none',
          overflowY: 'scroll',
        };
      },
      getCoeditHistoryContainerStyle: function () {
        return {
          display: this.tabIndex === 1 ? 'block' : 'none',
          maxHeight: '190px',
          minHeight: '48px',
          height: '100%',
          overflowX: 'none',
          overflowY: 'scroll',
        };
      },
      moreTenantUserCoeditsExist: function () {
        return this.tenantUserCoedits.length < this.tenantUserCoeditCount;
      },
    },
  };
</script>
